import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons"; // Updated to use the location pin icon

const AboutTrip = ({packageData}) => {
  console.log("abou trip",packageData)
  return (
    <div className="flex flex-col items-center p-10 gap-8 mt-4">
      {/* Stylish Heading Section */}
      <div className="flex justify-center p-4 bg-[#C3DAD9] w-full mb-8">
        <h1 className="flex items-center text-center text-3xl font-bold tracking-tight text-[#1F4644] sm:text-4xl md:text-5xl lg:text-5xl transition-colors duration-700 ease-in-out">
          <FontAwesomeIcon
            icon={faMapMarkerAlt} // Updated to location pin icon
            className="mr-4 text-3xl transition-transform duration-300 text-pink-600"
            style={{ fontSize: '4rem' }} // Icon size
          />
          <span className="text-[#1F4644] tracking-tighter">About this Incredible Trip!</span>
        </h1>
      </div>

      {/* Image with Blackish Shade */}
      <div className="w-full lg:w-3/4 flex justify-center mb-8">
        <img
          src={packageData?.Images}
          alt="Trip group"
          className="w-full h-full object-cover shadow-xl rounded-lg"
        />
      </div>

      {/* Text Section */}
      <div className="w-full lg:w-3/4">
        <h2 className="text-3xl font-semibold text-[#1F4644] mb-4">About the Trip</h2>
        <p className="text-base text-gray-700 mb-4 leading-relaxed">
         {
          packageData?.Overview
         }
        </p>
        {/* <p className="text-base text-gray-700 mb-4 leading-relaxed">
          While embarking on a journey, we satisfy ourselves by curating studies
          that go beyond the regular. Our Leh-Ladakh bike tours are meticulously
          crafted to cater to your precise goals and cravings for exhilaration.
        </p> */}
        {/* <a
          href="#"
          className="inline-block text-base font-semibold text-blue-600 hover:text-blue-800 transition-colors duration-300"
        >
          Read More
        </a> */}
      </div>
    </div>
  );
};

export default AboutTrip;
